// Component: ListRow.jsx
// Purpose: Generic mobile list row — a leading node, a title/subtitle stack, and
//   a trailing node, with an accent tap-flash (matches the search-result rows).
//   Renders as a <button> when `onClick` is given (tappable), else a plain <div>.
//   min-height 44px keeps it a comfortable touch target. Styling in
//   ds-components.css (.ds-list-row-*). Often the child of a SwipeRow.
//
// Usage:
//   <ListRow leading={<Avatar/>} title="RELIANCE" subtitle="NSE · Equity"
//            trailing={<Price/>} onClick={open} />

import React from "react";
import { cx } from "./cx";

export function ListRow({ leading, title, subtitle, trailing, onClick, className, ...props }) {
  const interactive = typeof onClick === "function";
  const content = (
    <>
      {leading != null && <span className="ds-list-row-leading">{leading}</span>}
      <span className="ds-list-row-body">
        {title != null && <span className="ds-list-row-title">{title}</span>}
        {subtitle != null && <span className="ds-list-row-subtitle">{subtitle}</span>}
      </span>
      {trailing != null && <span className="ds-list-row-trailing">{trailing}</span>}
    </>
  );

  if (interactive) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cx("ds-list-row", className)}
        {...props}
      >
        {content}
      </button>
    );
  }
  return (
    <div className={cx("ds-list-row", className)} {...props}>
      {content}
    </div>
  );
}

export default ListRow;
